import { Badge, cn } from '@teach/ui'
import type { PaymentListItem } from '@/features/ai/credits/paymentsApi'
import {
  paymentAmountText,
  paymentPackageText,
  paymentStatusLabel,
} from '@/features/ai/credits/lib/paymentHistoryRow'
import { formatDayYearTime } from '@/lib/formatDate'
import { useMessages } from '@/i18n'
import { messages } from './messages'

/** Колонки — общие со строкой заголовков (`PaymentsHeader`), чтобы не разъехались.
 *  Узкий экран — базовые классы, широкий — `sm:` (`max-*` в проекте не работают). */
export const TIME_COL = 'hidden w-40 shrink-0 sm:block'
export const PRICE_COL = 'shrink-0 text-right sm:w-24'
export const STATUS_COL = 'flex shrink-0 justify-end sm:w-28'

export const PaymentRow = ({ item }: { item: PaymentListItem }) => {
  const m = useMessages(messages)
  const status = paymentStatusLabel(item.status)
  // Время СОЗДАНИЯ заказа (`createdAt`): отдельного времени оплаты бэк не отдаёт.
  const time = formatDayYearTime(item.createdAt)
  return (
    <div className="flex items-center gap-3 border-b border-foreground/5 py-4 last:border-0 sm:gap-4">
      <span className={cn(TIME_COL, 'text-sm tabular-nums text-muted-foreground')}>{time}</span>
      {/* Картинки у пакета нет по контракту — карточка рисуется именем и суммой.
          На телефоне колонки времени нет — время второй строкой под именем. */}
      <span className="flex min-w-0 flex-1 flex-col">
        <span className="truncate text-base font-medium">
          {paymentPackageText(item.product?.name, m.creditsPackage, item.product?.credits)}
        </span>
        <span className="text-xs tabular-nums text-muted-foreground sm:hidden">{time}</span>
      </span>
      <span className={cn(PRICE_COL, 'text-base font-semibold tabular-nums')}>
        {paymentAmountText(item.finalPrice, item.priceCurrency)}
      </span>
      <span className={STATUS_COL}>
        <Badge
          variant="outline"
          className={cn(
            'shrink-0 px-3 py-1 text-sm',
            status.tone === 'positive' ? 'text-success' : null,
            status.tone === 'negative' ? 'text-destructive' : null,
            status.tone === 'neutral' ? 'text-muted-foreground' : null,
          )}
        >
          {status.label}
        </Badge>
      </span>
    </div>
  )
}
